module.exports = __webpack_public_path__ + "static/media/banner_sticker.cffd4bac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner_sticker.png
// module id = 316
// module chunks = 21